module.exports = __webpack_public_path__ + "static/media/sales-text-back.03c18503.svg";